import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsEarningMilesMocks: MicroMoments = {
  id: '',
  title: 'Congratulations, Jordan!',
  description:
    'You earned 1,480 more miles than last year. Celebrate by redeeming some Award Travel.',
  action: {
    label: 'Book With Miles',
    url: '/flight-search/book-a-flight?action=searchFlights&tripType=ROUND_TRIP&awardTravel=true&paxCount=1'
  },
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/upcoming-miles.gif',
    alt: 'Earning More Miles'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
